import React, { memo, forwardRef } from "react";
const SvgGreaterthan = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        fillRule="evenodd"
        d="M8.106 8.553a1 1 0 011.342-.447l14 7a1 1 0 010 1.789l-14 7a1 1 0 11-.895-1.789L20.764 16 8.554 9.895a1 1 0 01-.448-1.342z"
        clipRule="evenodd"
      />
    </svg>
  );
});
SvgGreaterthan.displayName = "SvgGreaterthan";
const MemoForwardRef = memo(SvgGreaterthan);
export default MemoForwardRef;
